import {selectAppData, useHMSActions, useHMSStore} from '@100mslive/react-sdk';
import {useCallback} from 'react';
import {APP_DATA, UI_SETTINGS} from '../common/constants';

/**
 * fields saved related to UI settings in store's app data can be
 * accessed using this hook. key is optional if not passed
 * the whole UI settings object is returned. Usage -
 * 1. val = useUiSettings("isAudioOnly");
 *    console.log(val); // false
 * 2. val = useUISettings();
 *    console.log(val); // {isAudioOnly: false}
 * @param {string | undefined} uiSettingKey
 */
export const useUISettings = (uiSettingKey: any) => {
  const value = useHMSStore(selectAppData(APP_DATA.uiSettings));
  if (value) {
    return uiSettingKey ? value[uiSettingKey] : value;
  }
};

/**
 * fields saved related to UI settings in store's app data can be
 * accessed using this hook. key is optional if not passed
 * the whole UI settings object is returned. Usage -
 * [val, setVal] = useUiSettings("isAudioOnly");
 * console.log(val); // false
 * setVal(true);
 * @param {string} uiSettingKey
 */
export const useSetUiSettings = (uiSettingKey: any) => {
  const actions = useHMSActions();
  const value = useUISettings(uiSettingKey);
  const setValue = useCallback(
    (newValue:any) => {
      actions.setAppData(APP_DATA.uiSettings, {[uiSettingKey]: newValue}, true);
    },
    [actions, uiSettingKey]
  );
  return [value, setValue];
};

export const useIsHeadless = () => {
  const isHeadless = useUISettings(UI_SETTINGS.isHeadless);
  return isHeadless;
};
